import { ComponentType } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { PATHS } from 'config/paths';

export const AuthGuard = ({
  component: Component
}: {
  component: ComponentType<object>;
}) => {
  const location = useLocation();

  const { isAuthenticated, user, isLoading } = useAuth0();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;

    return <Navigate to={PATHS.login} state={{ from: returnTo }} replace />;
  }

  if (isAuthenticated && user) {
    return <Component />;
  }

  return <Navigate to={PATHS.login} replace />;
};
